"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFormRow = void 0;
/**
 * Creates a single row for a {@link FluidFormLayout.ROW} layout form when
 * given a rowId, and an array of column spans.
 *
 * @param rowId
 * @param columns
 */
function createFormRow(rowId, columns) {
    return {
        rowId,
        columnOptions: columns.map((colSpan, columnId) => ({
            colSpan,
            columnId: columnId + 1,
        })),
    };
}
exports.createFormRow = createFormRow;
